/**
 * coπ → Grooves (Gordon 2026-11-02): "show me a reggae drum pattern", "play a
 * funk groove", "funk bass line", "visa trummönster för jazz", "pon un ritmo de
 * salsa", "montre-moi une ligne de basse funk" → /academy/grooves, playing.
 * Needs a groove word, so "play jazz" still plays jazz from the catalogue.
 * Works on coπ's normalised text (lower case, no accents or punctuation).
 */

// Words that mean "the pattern", in English, Swedish, Spanish and French.
const PATTERN = /\b(grooves?|drum ?patterns?|drum ?beats?|drum grooves?|beat patterns?|rhythm patterns?|bass ?lines?|bass grooves?|bass patterns?|walking bass|one drop|tumbao|four on the floor|trummonster|trummonstret|trumkomp(et)?|trumgroove|basgang(ar|en|arna)?|basslingor?|basgroove|ritmos?|patron(es)? de bateria|patrones de ritmo|lineas? de bajo|groove de bajo|rythmes?|motifs? de batterie|patterns? de batterie|lignes? de basse)\b/;

// Style names → groove ids. Order matters: longer and more specific first.
const STYLES: [RegExp, string][] = [
  [/\b(drum (and|n|&) bass|drum n bass|drumnbass|dnb|d n b|jungle|trummor och bas)\b/, 'dnb'],
  [/\b(r ?(and|&|n|och|y|et) ?b|rnb|neo ?soul)\b/, 'rnb'],
  [/\b(boom ?bap|hip ?hop|rap)\b/, 'boombap'],
  [/\b(uk garage|garage|2 step|two step)\b/, 'garage'],
  [/\b(reggaeton|regueton|dembow)\b/, 'dembow'],
  [/\b(reggae|one drop|dancehall)\b/, 'reggae'],
  [/\b(bossa ?nova|bossa|samba)\b/, 'bossa'],
  [/\b(salsa|tumbao|latin|latino|latina|latinamerikansk|clave)\b/, 'salsa'],
  [/\b(afro ?beats?|afrobeat|afro|highlife|amapiano)\b/, 'afrobeats'],
  [/\b(blues|shuffle|boogie)\b/, 'blues'],
  [/\b(jazz|jazzig|swing|walking bass)\b/, 'jazz'],
  [/\b(deep house|house)\b/, 'house'],
  [/\b(techno|tekno)\b/, 'techno'],
  [/\b(dubstep)\b/, 'dubstep'],
  [/\b(trap|drill)\b/, 'trap'],
  [/\b(disco)\b/, 'disco'],
  [/\b(funk|funky|funkig)\b/, 'funk'],
  [/\b(soul|motown)\b/, 'soul'],
  [/\b(heavy metal|metal|hardcore)\b/, 'metal'],
  [/\b(country|bluegrass|folk)\b/, 'country'],
  [/\b(rock|hard rock|rock n roll|rock and roll|pop|punk)\b/, 'rock'],
];

// Making a beat is EP-X's job ("skapa ett trumkomp på 90 bpm", "make a drum pattern in EPX").
const MAKE = /\b(make|making|create|build|program|produce|record|skapa|gor|gora|bygg|programmera|crea|crear|haz|hacer|produce|fais|faire|cree|creer|compose|composer)\b|\bep ?x\b/;

export function matchGroove(text: string): { href: string; name: string } | null {
  if (!PATTERN.test(text) || MAKE.test(text)) return null;
  for (const [re, id] of STYLES) {
    const m = re.exec(text);
    if (m) return { href: `/academy/grooves?g=${id}&play=1`, name: m[0] };
  }
  return { href: '/academy/grooves', name: 'grooves' };
}
